module.exports = __webpack_public_path__ + "static/media/offline.1ef869b5.svg";